import { addOutputNode } from 'actions/feature/outputs'

export const DELETE_FUNCTION = 'DELETE_FUNCTION'
export const deleteFunction = (payload) => (dispatch) => {
  dispatch({
    payload,
    type: DELETE_FUNCTION,
  })
}

export const ADD_FUNCTION = 'ADD_FUNCTION'
export const addFunction = (payload) => (dispatch) => {
  const { moduleType, tmpId, outputId, outputIndex } = payload
  dispatch({
    payload,
    type: ADD_FUNCTION,
  }).then(() => {
    dispatch(addOutputNode(moduleType, tmpId, outputId, outputIndex))
  })
}

export const SET_FUNCTION_FIELD = 'SET_FUNCTION_FIELD'
export const setFunctionField = (functionUri, paramName, value) => ({
  type: SET_FUNCTION_FIELD,
  functionUri,
  paramName,
  value,
})
